<template>
  <section class="container">
    <div class="route">
      {{$locales.ordenesgestionpagos.ordenesgestionpagos}} > {{$locales.ordenesgestionpagos.consultaordenesgestionpagos}} > {{ $locales.ordenesgestionpagos.detalletransferencia }}
    </div>
    <div class="wide-window">
      <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
        <p>check_circle</p>
        <h3>Operación realizada con éxito</h3>
      </div>
      <div class="mensajeError" v-else-if="confirmacion=='KO'">
        <p>cancel</p>
        <h3>{{mensajeError}}</h3>
      </div>
      <h1>{{$locales.ordenesgestionpagos.detalletransferencia}}</h1>
          <div v-if=datosFirmaSim>
            <SignatureComponent :queries="queries" :datosFirma="datosFirmaSim" :llamada="llamada" @aceptar="callBackAceptarSim" @cancelar="callBackCancelarSim"></SignatureComponent>
          </div>
      <div class="form-group">
        <div class="output" v-if="datosSalida">
          <md-table v-model="detalleTransferencia">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell><span class="cabeceraVertical">{{ item.label }}</span></md-table-cell>
              <md-table-cell>{{ item.value }} <span v-if="item.moneda">{{ item.moneda }}</span></md-table-cell>
            </md-table-row>
          </md-table>
          <hr/>
          <div class="firmaconSalida" v-if=datosFirma>
            <SignatureComponent :queries="queries" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>
        </div>
        <div class="AdvancePaymentsButtons">
            <!-- Boton volver -->
            <input class="btnSecondary" type="button" value="Volver" @click="volver">
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import SignatureComponent from './SignatureComponent';
export default {
    name : 'TransferDetailComponent',
    data(){
      return{
        firma:false,
        mensajeError:'Algo ha ido mal, vuelva a intentarlo transcurridos unos minutos', //mensaje de error por defecto
        confirmacion:null,
        datosFirma: null,
        datosFirmaSim: null,
        datosSalida:null
      }
    },
    created: function(){ //simulacion previa donde obtenemos datos que se muestran por pantalla
    var ventana=this;
    const baseURI = '/api-confirming/confirming/suppliers/orders/' + this.$route.params.order + '/transferDetail';
    let loader = this.$loading.show();
    this.$http.get(baseURI)
            .then((result) => {
              this.datosSalida=result.data.data; 
              this.detalleTransferencia = 
              [
                {label: 'N\u00B0 de orden',value: this.datosSalida.order.replace(/^(0+)/g, '')},
                {label: 'Deudor', value: this.datosSalida.debtor},
                {label: 'NIF deudor', value: this.datosSalida.debtorId},
                {label: 'Importe financiado', value: this.formatearMiles(this.datosSalida.financedAmount.amount), moneda: this.datosSalida.financedAmount.currency ? this.formatearMoneda(this.datosSalida.financedAmount.currency.code) : ''},
                {label: 'Vencimiento', value: this.transformarFecha(this.datosSalida.expiration)},
                {label: 'D\u00edas', value: this.datosSalida.days.replace(/^(0+)/g, '')},
                {label: 'Tipo inter\u00e9s', value: this.formatearMiles(this.datosSalida.interestRate)},
                {label: 'Intereses', value: this.formatearMiles(this.datosSalida.totalInterest.amount), moneda: this.datosSalida.totalInterest.currency ? this.formatearMoneda(this.datosSalida.totalInterest.currency.code) : ''},
                {label: 'Gastos', value: this.formatearMiles(this.datosSalida.expensesAmount.amount),moneda: this.datosSalida.expensesAmount.currency ? this.formatearMoneda(this.datosSalida.expensesAmount.currency.code) : ''},
                {label: 'Importe IVA', value: this.formatearMiles(this.datosSalida.ivaAmount.amount),moneda: this.datosSalida.ivaAmount.currency ? this.formatearMoneda(this.datosSalida.ivaAmount.currency.code) : ''},
                {label: 'Importe', value: this.formatearMiles(this.datosSalida.amount.amount),moneda: this.datosSalida.amount.currency ? this.formatearMoneda(this.datosSalida.amount.currency.code) : ''},
                {label: 'Referencia', value: this.datosSalida.reference},
                {label: 'Forma pago', value: this.datosSalida.methodPay},     
                {label: 'BIC', value: this.datosSalida.swiftCode}          
              ];
            })
            .catch(function (error) {
              if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    ventana.datosFirmaSim = error.response.data.result.errors[0].info;
                  }else{
                    if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                      ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                    }else{ //si no, por defecto
                      ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                    }
                    ventana.confirmacion='KO';
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }else{
                  if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                    ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                  }else{ //si no, por defecto
                    ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                  }
                  ventana.confirmacion='KO';
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  });
                }
              }
            })
            .then(function () {
              loader.hide();
            });
    },
    components: {
      SignatureComponent
    },
    methods: {
      formatearMoneda(coin) {
        if(coin=="EUR") {
          coin = "€"
          return coin;
        }else if(coin=="DOL") {
          coin = "$"
          return coin;
        }
      },
      transformarFecha(fecha) {
        var fechaFormateada = fecha.substring(0,10).split("-")[2] + "-" + fecha.split("-")[1] + "-" + fecha.split("-")[0];
        if(fechaFormateada.length == 10) {
          return fechaFormateada;
        } else {
          return "";
        }
        
      },
      formatearMiles(importe) {
        importe = importe.toString().split('.');
        if(importe[0].length > 3) {
          importe[0] += '';
          var x = importe[0].split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
              x1 = x1.replace(rgx, '$1' + '.' + '$2');
          }
          importe[0] = x1 + x2;
          return importe.join(',');
        } else {
          return importe.join(',');
        }
      },
      volver(){
        this.$router.push({ name:'consultaOrdenesGestionPagos', 
          params: { 
            deudor:this.$route.params.deudor, 
            fechaDesde : this.$route.params.fechaDesde, 
            fechaHasta : this.$route.params.fechaHasta, 
            fechaAltaDesde : this.$route.params.fechaAltaDesde, 
            fechaAltaHasta : this.$route.params.fechaAltaHasta, 
            importeDesde : this.$route.params.importeDesde, 
            importeHasta : this.$route.params.importeHasta,
            concepto : this.$route.params.concepto,
            estado : this.$route.params.estado
          }
        });
      }
    }
}
</script>